/**
 * This method returns an empty string.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {string} Returns the empty string.
 * @example
 *
 * _.times(2, _.stubString);
 * // => ['', '']
 */
function stubString() {
  return '';
}

module.exports = stubString;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/stubString.js
// module id = 1396
// module chunks = 35783957827783